export default "__VITE_ASSET__8f7bbe8a__"